module.exports = __webpack_public_path__ + "img/p_bg1.3f7914ca.jpg";